module.exports = __webpack_public_path__ + "img/knud-hvid.e2dcdb88.png";